import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Home from '../Pages/Home/Home';
import About from '../Pages/About/About';
import Contact from '../Pages/Contact/Contact';
import HealthInsurnace from '../Pages/HealthInsurance/HealthInsurnace';
import HealthQuatation from '../Pages/HealthQuatation/HealthQuatation';
import Posp from '../Pages/Posp';
import Bike from '../Pages/Bike/Bike';
import HealthPolicyDetails from '../Pages/HealthPolicyDetails/HealthPolicyDetails';
import PospRegistration from '../Pages/Posp/PospRegister';
import BikeQuotation from '../Pages/BikeQuotation';
import BikePolicyDetails from '../Components/BikePolicyDetails';
import BikePolicyPayment from '../Pages/BikePolicyPayment/BikePolicyPayment';
import ViewAllFeatures from '../Components/HealthPolicyDetail/ViewAllFeatures';
import HealthProposalForm from '../Pages/HealthProposalForm/HealthProposalForm';
import CarQuotation from '../Pages/CarQuotation';
import CarPolicyPayment from '../Pages/CarPolicyPayment';
import ComparePolicy from '../Pages/ComparePolicy/ComparePolicy';
import LifeInsurance from '../Pages/LifeInsurance/LifeInsurance';
import LifeQuotation from '../Pages/LifeQuotation/LifeQuotation';
import LifePolicyDetails from '../Pages/LifePolicyDetails/LifePolicyDetails';
import LifeProposalForm from '../Pages/LifeProposalForm/LifeProposalForm';
import CommercialVehicle from '../Pages/CommercialVehicle/CommercialVehicle';
import CVQuotation from '../Pages/CVQuotation/CVQuotation';
import CvPolicyDetails from '../Pages/CvPolicyDetails/CvPolicyDetails';
import Car from '../Pages/Car/Car';
import MainLayout from '../MainLayout/MainLayout';
import OurPhilosophy from '../Pages/OurPhilosophy/OurPhilosophy';
import ScrollToTopAuto from '../Layout/ScrollToTopAuto/ScrollToTopAuto';

function Router() {
    const location = useLocation();
    const showSmallNavbar = !['/', '/about', '/contact', '/posp',
        `${process.env.PUBLIC_URL}`,
        `${process.env.PUBLIC_URL}/`, `${process.env.PUBLIC_URL}/about`,
        `${process.env.PUBLIC_URL}/contact`, `${process.env.PUBLIC_URL}/posp`,
        `${process.env.PUBLIC_URL}/posp/registration`,
        `${process.env.PUBLIC_URL}/our-philosophy`,
        `${process.env.PUBLIC_URL}`,
    ].includes(location.pathname);

    return (
        <>
            <ScrollToTopAuto />
            <MainLayout showSmallNavbar={showSmallNavbar}>
                <Routes>
                    <Route path={`${process.env.PUBLIC_URL}/`} element={<Home />} />
                    <Route path={`${process.env.PUBLIC_URL}/about`} element={<About />} />
                    <Route path={`${process.env.PUBLIC_URL}/our-philosophy`} element={<OurPhilosophy />} />
                    <Route path={`${process.env.PUBLIC_URL}/contact`} element={<Contact />} />
                    <Route path={`${process.env.PUBLIC_URL}/posp`} element={<Posp />} />
                    <Route path={`${process.env.PUBLIC_URL}/posp/registration`} element={<PospRegistration />} />

                    {/* For health insurance */}
                    {/* <Route path={`${process.env.PUBLIC_URL}/health-insurance`} element={<HealthInsurnace />} />
                <Route path={`${process.env.PUBLIC_URL}/health-insurance/health-quotation`} element={<HealthQuatation />} />
                <Route path={`${process.env.PUBLIC_URL}/health-insurance/health-policy-details`} element={<HealthPolicyDetails />} />
                <Route path={`${process.env.PUBLIC_URL}/health-insurance/view-features`} element={<ViewAllFeatures />} />
                <Route path={`${process.env.PUBLIC_URL}/health-insurance/health-proposal-form`} element={<HealthProposalForm />} /> */}

                    {/* For bike insurance */}
                    {/* <Route path={`${process.env.PUBLIC_URL}/motor-insurance`} element={<Bike />} /> */}
                    {/* <Route path={`${process.env.PUBLIC_URL}/motor-insurance/bike-policy-list`} element={<BikeQuotation />} /> */}
                    {/* <Route path={`${process.env.PUBLIC_URL}/motor-insurance/bike-policy-details`} element={<BikePolicyDetails />} /> */}
                    {/* <Route path={`${process.env.PUBLIC_URL}/motor-insurance/bike-policy-summary-payment`} element={<BikePolicyPayment />} /> */}
                    <Route path={`${process.env.PUBLIC_URL}/motor-insurance/car-insurnace`} element={<Car />} />
                    <Route path={`${process.env.PUBLIC_URL}/motor-insurance/car-policy-list`} element={<CarQuotation />} />
                    <Route path={`${process.env.PUBLIC_URL}/motor-insurance/car-policy-details`} element={<CarPolicyPayment />} />
                    {/* <Route path={`${process.env.PUBLIC_URL}/motor-insurance/policy-compare-page`} element={<ComparePolicy />} /> */}

                    {/* For Life insurance */}
                    {/* <Route path={`${process.env.PUBLIC_URL}/life-insurance`} element={<LifeInsurance />} />
                <Route path={`${process.env.PUBLIC_URL}/life-insurance/life-policy-list`} element={<LifeQuotation />} />
                <Route path={`${process.env.PUBLIC_URL}/life-insurance/life-policy-list/life-policy-details`} element={<LifePolicyDetails />} />
                <Route path={`${process.env.PUBLIC_URL}/life-insurance/life-policy-list/life-policy-details/life-policy-proposalForm`} element={<LifeProposalForm />} /> */}

                    {/* For commercial vehicle insurance */}
                    {/* <Route path={`${process.env.PUBLIC_URL}/cv-insurance`} element={<CommercialVehicle />} />
                <Route path={`${process.env.PUBLIC_URL}/cv-insurance/cv-insurance-policy-list`} element={<CVQuotation />} />
                <Route path={`${process.env.PUBLIC_URL}/cv-insurance/cv-insurance-policy-list/cv-insurance-policy-detail`} element={<CvPolicyDetails />} /> */}

                </Routes>
            </MainLayout>
        </>
    );
}

export default Router;
